import members from '@/utils/user'

export default {
  namespaced: true,
  state: {
    userInfo: null
  },
  mutations: {
    SET_USER(state, payload) {
      state.userInfo = payload
    }
  },
  actions: {
    async GET_USER({ commit }) {
      members.getUser((res) => {
        commit('SET_USER', res)
        // console.log(res)
      })
    }
  }
}

